import React from "react"
import { FormattedMessage } from "react-intl"
import ActionButton from "../../button/actionbutton.component"
import Icon from "../../icon/icon.component"

type ItemDeleteButtonProps = {
    className: string
    title: string
    uniqueId: string
    handleDeleteRowCallback: (e) => void
}


const ItemDeleteButton = (props: ItemDeleteButtonProps) => {

    const handleDeleteRow = (e) => {
        props.handleDeleteRowCallback(e)
    }

    return(<span className={"" + props.className}>
        <form>
            <button title={props.title} id={props.uniqueId} type="button"
                className="btn btn-sm btn-outline-primary px-1" data-toggle="dropdown"
                aria-haspopup="false" aria-expanded="false">
                <Icon value="ellipsis-h" className="px-1" />
            </button>
            <div className="dropdown-menu">
                <ActionButton className="dropdown-item btn-sm btn-danger text-danger" type="button"
                    onClick={(e) => handleDeleteRow(e)}>
                    <Icon value={"trash"} className="mr-1" />
                    <label className="mb-0">
                        <FormattedMessage
                            id="quote.add_item_modal.delete_label"
                            defaultMessage="Delete"
                        />
                    </label>
                </ActionButton>
            </div>
        </form>
    </span>)
}

export default ItemDeleteButton


// WEBPACK FOOTER //
// ./src/common/quote/component/ItemDeleteButton.tsx